import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuardService} from 'compob2b-auth';
import {CatalogListComponent} from './catalog-list/catalog-list.component';

const routes: Routes = [
  {
    path: '', // path is: /catalog
    component: CatalogListComponent,
    canActivate: [AuthGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogRoutingModule { }
